import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import clsx from 'clsx';

import { PointsDisplay } from 'C4';

const capped = (value, cap, minMax = 'max') => {
  if (typeof cap === 'object') {
    const { min, max } = cap;

    if (value <= min) return min;
    if (value >= max) return max;

    return value;
  }

  if (minMax === 'max') return value >= cap ? cap : value;
  if (minMax === 'min') return value <= cap ? cap : value;

  throw Error('minMax parameter should be either min or max');
};

export default class PointsAlert extends Component {
  constructor(props) {
    super(props);

    const { tiers, points, pointsGained } = this.props;
    const i = Math.min(this.getTieredValue(), tiers.length - 1);

    const pointsToLevel = capped(tiers[i].points - (points - pointsGained), {
      min: 0,
      max: tiers[tiers.length - 1].points,
    });

    this.state = {
      pointsToLevel,
      startingValue: Math.max(0, points - pointsGained),
      pointsCounter: capped(Math.max(0, points - pointsGained), tiers[tiers.length - 1].points),
      transitions: {},
      nextRank: tiers[i].title,
      rankedUp: null,
    };

    this.getTieredValue = this.getTieredValue.bind(this);
  }

  componentDidMount() {
    const { points } = this.props;
    if (points > 0) {
      this.startCounting();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    clearInterval(this.interval);
  }

  getTieredValue(array = null, pointsOverride = null) {
    const { tiers, points: pointsProp } = this.props;
    const { pointsCounter } = this.state || {};
    let index = 0;
    tiers.forEach(({ points }, i) => {
      // Could be improved, maybe using filter / reduce?
      const currentPoints = pointsOverride || (pointsCounter === undefined ? pointsProp : pointsCounter);
      if (currentPoints > points) {
        index = i;
      }
    });

    if (array) return array[capped(index, 0, 'min')];
    return index;
  }

  startCounting() {
    const { delay, pointsGained, tiers, points } = this.props;
    const { startingValue } = this.state;

    const ranksGained = tiers.filter(({ points: p }) => p > startingValue).filter(({ points: p }) => p < points).length;

    this.timeout = setTimeout(() => {
      this.interval = setInterval(() => {
        const { pointsCounter, rankedUp } = this.state;
        const transitionTime = Math.floor(1000 / pointsGained);
        const { points: nextLevelPoints, copy: nextLevelCopy } = tiers[
          Math.min(this.getTieredValue() + 1, tiers.length - 1)
        ];

        const width = `${transitionTime}ms`;
        const height = `${transitionTime}ms`;

        if (!rankedUp && pointsCounter + 1 > nextLevelPoints && pointsCounter < points) {
          clearInterval(this.interval);
          this.setState({ rankedUp: nextLevelCopy, pointsToLevel: nextLevelPoints - pointsCounter });
          setTimeout(() => {
            this.startCounting();
          }, 2000);
          return;
        }

        const { points: maxedPoints } = tiers[tiers.length - 1];
        const maxed = pointsCounter === maxedPoints;
        if (!maxed) {
          this.setState({
            pointsToLevel: nextLevelPoints - (pointsCounter + 1),
            pointsCounter: Math.min(pointsCounter + 1, maxedPoints),
            transitions: { width, height },
            nextRank: tiers[Math.min(this.getTieredValue(), tiers.length - 1)].title,
            rankedUp: null,
          });
        }

        if (pointsCounter + 1 === points) {
          clearInterval(this.interval);
        }
      }, Math.floor(2000 / (pointsGained / (ranksGained + 1))));
    }, delay);
  }

  render() {
    const { icon } = this.props;
    // const { pointsToLevel, pointsCounter, transitions, startingValue, nextRank, rankedUp } = this.state;

    // const { title, points } = tiers[tiers.length - 1];

    return (
      <div className="wrapper__alert">
        {icon && <img src={icon} alt="completion icon" />}
        {/* <PointsDisplay
          tiers={tiers.map(({ points: p }) => p)}
          points={pointsCounter}
          startingValue={startingValue}
          animationDelay={1000}
          transitions={transitions}
          singleTier
        />
        {nextRank && !(title === nextRank && pointsCounter === points) && (
          <p>
            {i18n.translate('points.pointsToLevel', {
              pointsToLevel,
              points: 'XP',
              rank: nextRank.toUpperCase(),
            })}
          </p>
        )} */}
        {/* <h2 className={clsx({ open: rankedUp })}>{rankedUp || ''}</h2> */}
      </div>
    );
  }
}

PointsAlert.propTypes = {
  tiers: PropTypes.arrayOf(PropTypes.shape()),
  points: PropTypes.number,
  pointsGained: PropTypes.number,
  icon: PropTypes.string,
  delay: PropTypes.number,
};

PointsAlert.defaultProps = {
  tiers: [],
  points: 0,
  pointsGained: 0,
  icon: null,
  delay: 0,
};
